import { Stack, styled } from "@mui/material";

export const StyledAccountSetupStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
  width: "504px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
